import * as React from 'react';

function SvgUploadIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30" {...props}>
    <path
      fill="#363D43"
      d="m10.066 8.558 3.435-3.45v14.386a1.5 1.5 0 0 0 3 0V5.108l3.436 3.45a1.5 1.5 0 0 0 2.13 0 1.5 1.5 0 0 0 0-2.13l-6-6a1.5 1.5 0 0 0-.496-.315 1.5 1.5 0 0 0-1.14 0 1.5 1.5 0 0 0-.495.315l-6 6a1.506 1.506 0 0 0 2.13 2.13m18.436 6.436a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5H4.5a1.5 1.5 0 0 1-1.5-1.5v-9a1.5 1.5 0 0 0-3 0v9a4.5 4.5 0 0 0 4.5 4.501h21.002a4.5 4.5 0 0 0 4.5-4.5v-9.001a1.5 1.5 0 0 0-1.5-1.5"
    />
  </svg>)
}
export default SvgUploadIcon;
